module.exports = __webpack_public_path__ + "static/img/layout4.6df94f9b.png";